"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReinstateTagStatus = void 0;
var ReinstateTagStatus;
(function (ReinstateTagStatus) {
    ReinstateTagStatus["Posted"] = "Posted on Sign Structure";
    ReinstateTagStatus["Returned"] = "Returned to Department";
    ReinstateTagStatus["Destroyed"] = "Destroyed or Damaged";
})(ReinstateTagStatus || (exports.ReinstateTagStatus = ReinstateTagStatus = {}));
